import Board from "../models/board";
import { apiResultSuccess, getNotes } from "../apihelper";
import Note from "../models/note";

export default class NotesController extends Board {
    constructor(
        id=-1, 
        title='', 
        type='', 
        orderIndex=-1,
        dateCreated='', 
        lastUpdated='', 
        hidden=false
    ) {
        super(id, title, type, orderIndex, dateCreated, lastUpdated, hidden);

        this.notes = [];
    }

    getNotes() {
        return this.notes;
    }

    setNotes(newNotes=[]) {
        this.notes = newNotes;
    }

    // API helper
    // Checks for success result
    // Upon success calls createNotes
    // Runs reload on subject
    handleAPIResult(results) {
        if ( apiResultSuccess(results) ) {
            if ( results.notes ) {
                this.createNotes(results.notes);

                if ( this.subject ) {
                    this.subject.runReload();
                }
            }
        }
    }


    async fetchData() {
        return this.fetchNotes();
    }

    // Fetch notes data from API
    // When done, call handleAPIResult fn
    fetchNotes() {
        getNotes(
            (results) => {
                this.handleAPIResult(results)
            }, parseInt(this.id)
        )
    }

    // Refetch notes
    async reloadData() {
        return this.fetchData();
    }

    // Iterates through newNotes
    // Creates a Note object for each 
    // then adds it to a new notes array
    // Updates notes property with new array
    createNotes(newNotes=[]) {
        const notes = [];

        newNotes.forEach(noteData => {
            const newNote = new Note(noteData);
            notes.push(newNote);
        });
        this.setNotes(notes);
    }

    // Creates a new Note from newNoteData
    // Adds it to notes array
    // Notifies subject to reload
    addNew(newNoteData) {
        const newNote = new Note(newNoteData);
        newNote.animate = true;
        this.notes.unshift(newNote);

        this.subject.runReload();
    }

    // Filters notes array by id
    // Assigns to notes
    // Notifies subject to reload
    delete(id=-1) {
        if ( id !== -1 ) {
			const newNotes = this.notes.filter(note => note.id !== id);
            this.setNotes(newNotes);
            this.subject.runReload();
        }
    }
}
